import React, { useState } from "react";
import { Package, Search } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function MyOrders() {
  const [email, setEmail] = useState(localStorage.getItem("davide_shopper_email") || "");
  const [orders, setOrders] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchOrders = async (e) => {
    e?.preventDefault();
    if (!email.trim()) { toast.error("Enter your email"); return; }
    setLoading(true);
    try {
      const { data } = await api.get(`/orders`, { params: { email: email.trim() } });
      setOrders(data);
      localStorage.setItem("davide_shopper_email", email.trim());
    } catch {
      toast.error("Could not fetch orders");
    } finally { setLoading(false); }
  };

  return (
    <div className="pt-32 pb-24 min-h-screen" data-testid="my-orders-page">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <p className="overline mb-4">Your Purchases</p>
        <h1 className="font-display text-5xl md:text-6xl font-light text-white tracking-tighter">My Orders.</h1>
        <p className="text-white/60 mt-3">Enter the email you used at checkout to see your DaviDÉ history.</p>

        <form onSubmit={fetchOrders} className="flex gap-3 mt-10">
          <input type="email" value={email} onChange={(e)=>setEmail(e.target.value)}
            data-testid="orders-email-input"
            placeholder="you@example.com" required
            className="flex-1 bg-transparent border border-white/20 px-4 py-3 text-white focus:border-[var(--davide-gold)] outline-none transition-colors" />
          <button type="submit" disabled={loading} className="btn-gold" data-testid="orders-fetch-btn">
            <Search size={14}/> {loading ? "…" : "Find"}
          </button>
        </form>

        {orders !== null && (
          <div className="mt-12 space-y-6" data-testid="orders-list">
            {orders.length === 0 ? (
              <div className="text-center border border-white/10 bg-[#101010] p-16" data-testid="orders-empty">
                <Package size={48} className="text-white/30 mx-auto mb-4" />
                <p className="font-display text-2xl text-white">No orders yet.</p>
                <p className="text-white/50 text-sm mt-2">Once you check out, your orders will appear here.</p>
              </div>
            ) : (
              orders.map((o) => (
                <div key={o.id} className="border border-white/10 bg-[#101010] p-6" data-testid={`order-${o.id}`}>
                  <div className="flex flex-wrap justify-between items-baseline gap-2 mb-4">
                    <div>
                      <p className="overline">
                        {(o.provider || "stripe").toUpperCase()} · {new Date(o.created_at).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" })}
                      </p>
                      <p className="text-white/40 text-xs mt-1">#{o.session_id?.slice(-12)}</p>
                    </div>
                    <div className="text-right">
                      <p className="font-display text-3xl text-[var(--davide-gold)]">${Number(o.amount).toFixed(2)}</p>
                      <p className="text-xs text-white/50 mt-1 uppercase tracking-widest">{o.payment_status}</p>
                    </div>
                  </div>
                  <div className="space-y-1 text-sm text-white/70">
                    {(o.items || []).map((it, idx) => (
                      <div key={idx}>· {it.quantity}× {it.product_id?.slice(0, 8)} {it.size ? `(${it.size})` : ""}</div>
                    ))}
                    {o.discount_code && (
                      <div className="text-[var(--davide-gold)] text-xs mt-2 tracking-widest uppercase">
                        Discount: {o.discount_code} (−${Number(o.discount_amount || 0).toFixed(2)})
                      </div>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
}
